import React from 'react';

import { useTranslation } from 'react-i18next';

export function InspectionsTemplateLibrary() {
  const { t } = useTranslation();

  return (
    <div style={{ padding: '2rem' }}>
      <h1>{t('web.admin.inspections.templateLibrary.title')}</h1>
      <p>{t('web.admin.inspections.templateLibrary.placeholder')}</p>
    </div>
  );
}
